<template>
  <ion-header v-if="is_logged_in">
    <ion-toolbar class="desktop-nav">
      <ion-buttons slot="secondary">
        <!-- <ion-button v-if="userProfile.admin" @click="gotoDashboard">Dashboard</ion-button> -->
        <ion-button @click="gotoHome">Home</ion-button>
        <ion-button @click="gotoNewVisit">New Visit</ion-button>
        <ion-button @click="gotoScan">Scan</ion-button>
        <ion-button @click="gotoVisits">Visits</ion-button>
        <ion-button @click="gotoVisitors">Visitors</ion-button>
        <ion-button @click="gotoProducts">Products</ion-button>
        <ion-button @click="gotoInventory">Inventory</ion-button>
        <ion-button @click="logout">Logout</ion-button>
      </ion-buttons>
      <ion-buttons>
      </ion-buttons>
      <ion-title class="logo" @click="gotoHome">{{ name }} </ion-title>
      <ion-title class="logo2" @click="gotoHome">{{ name2 }} </ion-title>
    </ion-toolbar>
    <ion-toolbar class="mobile-nav">
      <ion-buttons slot="start">
        <ion-menu-button auto-hide="false" @click="openMenu"></ion-menu-button>
      </ion-buttons>
      <ion-buttons slot="primary">
        <ion-button>
          <ion-icon slot="icon-only" ios="ellipsis-horizontal" md="ellipsis-vertical"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ name }}</ion-title>
    </ion-toolbar>
  </ion-header>
	<ion-menu side="start" content-id="menuContent">
		<ion-content>
			<ion-list>
				<ion-item class="logo-item">
					<ion-label>{{ name }}</ion-label>
				</ion-item>
				<ion-item @click="gotoHome">
					<ion-label>Home</ion-label>
				</ion-item>
				<ion-item @click="gotoNewVisit">
					<ion-label>New Visit</ion-label>
				</ion-item>
				<ion-item @click="gotoScan">
					<ion-label>Scan</ion-label>
				</ion-item>
				<ion-item @click="gotoVisits">
					<ion-label>Visits</ion-label>
				</ion-item>
				<ion-item @click="gotoVisitors">
					<ion-label>Visitors</ion-label>
				</ion-item>
				<ion-item @click="gotoProducts">
					<ion-label>Products</ion-label>
				</ion-item>
				<ion-item @click="gotoInventory">
					<ion-label>Inventory</ion-label>
				</ion-item>
				<ion-item @click="logout">
					<ion-label>Logout</ion-label>
				</ion-item>
			</ion-list>
		</ion-content>
	</ion-menu>
</template>

<script>
import { IonToolbar, IonMenuButton, IonLabel, IonItem, IonList, IonContent, IonMenu, IonHeader, IonTitle, IonIcon, IonButtons, IonButton, menuController } from "@ionic/vue";
import { ellipsisVertical, menuOutline } from "ionicons/icons";
import { mapGetters } from 'vuex';
//import Subscription from "./Subscription";

export default {
  name: "recent-list",
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: { IonIcon, IonMenuButton, IonList, IonLabel, IonItem, IonContent, IonMenu, IonToolbar, IonHeader, IonTitle, IonButtons, IonButton },
  computed: {
    ...mapGetters(['loginToken', 'userProfile']),
    is_logged_in() {
      return this.$store.getters.isAuthenticated;
    }
  },
  setup() {
    return {
      ellipsisVertical,
      menuOutline,
      name: "<TechConf-db />",
      name2: "TC-db",
    };
  },
  data() {
    return {
      searchString: ""
    }
  },
  mounted() {
      if(process.env.VUE_APP_CUSTOMER=='jiunho'){
        this.logo = require('@/theme/jiunho.png');
        this.name = 'Jiun Ho';
        this.name2 = 'Jiun Ho';
      } else if(process.env.VUE_APP_CUSTOMER=='sandrajordan'){
        this.logo = require('@/theme/sandrajordan.png');
        this.name = 'Sandra Jordan';
        this.name2 = 'Sandra Jordan';
      } else if(process.env.VUE_APP_CUSTOMER=='leondemo'){
        this.logo = require('@/theme/leondemo.png');
        this.name = 'Leon Sales System';
        this.name2 = 'Leon Sales System';
      }
  },
  methods: {
    async openMenu() {
      await menuController.open("start");
    },
    async gotoHome() {
      this.$router.push("/home");
      await menuController.close("start");
    },
    async gotoNewVisit() {
      this.$router.push("/newvisit");
      await menuController.close("start");
    },
    async gotoScan() {
      this.$router.push({ name:'Scan', params:{ open_scan:1 }});
      await menuController.close("start");
    },
    async gotoVisits() {
      this.$router.push("/visits");
      await menuController.close("start");
    },
    async gotoVisitors() {
      this.$router.push("/customers");
      await menuController.close("start");
    },
    async gotoProducts() {
      this.$router.push({ name:"Products", params:{pitem_id:0}});
      await menuController.close("start");
    },
    async gotoInventory() {
      this.$router.push("/inventory");
      await menuController.close("start");
    },
    logout() {
      this.$store.dispatch("logout").then(async () => {
        //this.$router.push("/");
        this.$router.replace('/login');
        await menuController.close("start");
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>

<style lang="scss" scoped>

ion-toolbar, ion-menu-button, ion-button {
  --background: #144d75;
  --color: #ffffff;
  font-weight: 700;
}

ion-button.sign-out {
  font-size: 17px;
  font-weight: 500;
  margin-left: 5px;
  float: left;
  --color: #ffffff;
}

.ellipsis {
  color: #ffffff;
}

ion-title.logo {
  font-weight: 900;
  font-size: 25px;
  // text-align: center;
}

ion-list {
  padding-top: 0;
}

ion-item.logo-item {
  --background: #144d75;
  color: #fff;
  font-weight: bold;
  line-height: 30px;
}
</style>
